(() => {
  const storage = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch {} }
  };
  const context = () => {
    const node = document.querySelector('[data-cosmic-artwork-context]');
    return node ? { artwork_id: node.dataset.productId, artwork_handle: node.dataset.productHandle, artwork_title: node.dataset.productTitle } : { artwork_handle: '' };
  };
  const track = (name, data) => {
    try { const result = window.Shopify?.analytics?.publish?.(`cosmic:${name}`, data); result?.catch?.(() => {}); } catch {}
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof window.gtag === 'function' && privacy?.analyticsProcessingAllowed?.()) {
      window.gtag('event', name, data);
    }
    document.dispatchEvent(new CustomEvent('cosmic:analytics', { detail: { name, data } }));
  };
  const bind = () => {
    document.querySelectorAll('[data-cosmic-share]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const url = new URL(location.href); url.search = ''; url.hash = '';
        if (navigator.share) {
          try { await navigator.share({ title: button.dataset.title, url: url.href }); return; }
          catch (error) { if (error.name === 'AbortError') return; }
        }
        try {
          if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(url.href);
          else {
            const input = document.createElement('textarea'); input.value = url.href;
            input.style.cssText = 'position:fixed;left:-9999px'; document.body.append(input);
            input.select(); const copied = document.execCommand('copy'); input.remove();
            if (!copied) throw new Error('Clipboard unavailable');
          }
          button.textContent = button.dataset.copied;
          button.setAttribute('role', 'status');
        } catch { window.prompt(button.dataset.error, url.href); }
      });
    });
    const dialog = document.querySelector('[data-cosmic-lightbox]');
    document.querySelectorAll('[data-cosmic-zoom]').forEach(link => {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', event => {
        if (!dialog?.showModal) return;
        event.preventDefault();
        const img = dialog.querySelector('[data-cosmic-zoom-image]');
        img.src = link.href; img.alt = link.dataset.zoomAlt || ''; img.classList.remove('full-size');
        dialog.showModal();
      });
    });
    if (dialog && !dialog.dataset.bound) {
      dialog.dataset.bound = 'true';
      dialog.querySelector('[data-cosmic-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.querySelector('[data-cosmic-zoom-image]').addEventListener('click', event => event.target.classList.toggle('full-size'));
    }
    document.querySelectorAll('[data-cosmic-offer]').forEach(link => {
      if (link.dataset.bound) return; link.dataset.bound = 'true';
      link.addEventListener('click', () => {
        const select = document.querySelector('#CosmicRequestType'); if (select) select.value = 'Offer';
        setTimeout(() => document.querySelector('#CosmicOfferAmount')?.focus({ preventScroll: true }), 150);
      });
    });
    document.querySelectorAll('.cosmic-contact-form').forEach(form => {
      if (form.dataset.enquiryBound) return; form.dataset.enquiryBound = 'true';
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        storage.set('cosmic_pending_enquiry', { id: globalThis.crypto?.randomUUID?.() || String(Date.now()), ...context() });
      });
    });
    if (document.querySelector('[data-cosmic-enquiry-success]')) {
      const pending = storage.get('cosmic_pending_enquiry');
      if (pending) { track('enquiry_submitted', { ...pending, method: 'email' }); storage.remove('cosmic_pending_enquiry'); }
    }
    document.querySelectorAll('[data-cosmic-filters]').forEach(form => {
      if (form.dataset.bound) return; form.dataset.bound = 'true';
      const cards = [...document.querySelectorAll('[data-catalogue-card]')];
      const artist = form.querySelector('[data-filter-artist]'), technique = form.querySelector('[data-filter-technique]');
      const min = form.querySelector('[data-filter-min]'), max = form.querySelector('[data-filter-max]');
      for (const [select, field] of [[artist, 'artist'], [technique, 'technique']]) {
        [...new Set(cards.map(card => card.dataset[field]).filter(Boolean))].sort().forEach(value => select.add(new Option(value, value)));
      }
      const current = new URL(location.href);
      for (const [input, key] of [[artist, 'c_artist'], [technique, 'c_tech'], [min, 'c_min'], [max, 'c_max']]) input.value = current.searchParams.get(key) || '';
      const filter = () => {
        let count = 0;
        cards.forEach(card => {
          const price = Number(card.dataset.price);
          const match = (!artist.value || card.dataset.artist === artist.value) && (!technique.value || card.dataset.technique === technique.value)
            && (!min.value || (price > 0 && price >= Number(min.value))) && (!max.value || (price > 0 && price <= Number(max.value)));
          card.hidden = !match; if (match) count++;
        });
        const status = form.querySelector('[data-filter-count]'); status.textContent = `${count} ${status.dataset.label}`;
        document.querySelector('[data-filter-empty]').hidden = count !== 0;
        const url = new URL(location.href);
        for (const [input, key] of [[artist, 'c_artist'], [technique, 'c_tech'], [min, 'c_min'], [max, 'c_max']]) {
          if (input.value) url.searchParams.set(key, input.value); else url.searchParams.delete(key);
        }
        history.replaceState(null, '', url);
      };
      form.addEventListener('input', filter); form.addEventListener('submit', event => { event.preventDefault(); filter(); });
      form.addEventListener('reset', () => setTimeout(filter, 0)); filter();
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href^="https://wa.me/"]');
    if (link) track('whatsapp_click', { ...context(), method: 'whatsapp' });
  });
  bind(); document.addEventListener('shopify:section:load', bind);
})();
